// Realtime channels (spec/09-realtime-protocol.md §3).
//
// A subscription to a channel the principal may not see returns `err` with `forbidden`. Which
// principal may see which channel is the gateway's to enforce; the names are the contract's.
//
// The channel names, the pattern and the constructors are plain values, so they live in
// `./constants.ts` (which imports no Zod) and are re-exported here; only `ChannelSchema` — the one
// thing that needs `.openapi()` — stays in this file. A browser that needs a channel name imports it
// from `@clavian/contracts/constants`, never this module, to keep `new Function` out of the bundle.
import { z } from "../zod.js";
import { CHANNEL_PATTERN, channels, isChannel, STATION_CHANNEL_TOPICS, VENUE_CHANNEL_TOPICS, } from "./constants.js";
export { CHANNEL_PATTERN, channels, isChannel, STATION_CHANNEL_TOPICS, VENUE_CHANNEL_TOPICS, };
export const ChannelSchema = z
    .string()
    .regex(CHANNEL_PATTERN, 'Not a channel name from spec/09 §3')
    .openapi('RealtimeChannel', {
    description: 'A realtime channel, for example "venue:ven_01j8…:floor".',
    example: 'station:stn_01j8f7q0r2s3t4u5v6w7x8y9z0',
});
//# sourceMappingURL=channel.js.map